import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { countries } from '../../../mocks/countries';
import { buildEcommerceItem, trackEcommerceEvent } from '../../../lib/analytics';

const ITEM_LIST_ID = 'country_grid';
const ITEM_LIST_NAME = 'Landing country grid';

export default function Countries() {
  const { t } = useTranslation();

  const items = useMemo(() => countries.map(country => buildEcommerceItem({
    countryCode: country.code,
    countryName: country.name,
  })), []);

  useEffect(() => {
    trackEcommerceEvent('view_item_list', items, {
      item_list_id: ITEM_LIST_ID,
      item_list_name: ITEM_LIST_NAME,
    });
  }, [items]);

  return (
    <section id="countries" className="bg-bg">
      <div className="mx-auto max-w-5xl px-5 py-14 md:py-18">
        <div className="text-center mb-8">
          <h2 className="text-[24px] md:text-[28px] font-bold tracking-tight">{t('countries.section.title')}</h2>
          <p className="mt-2 text-[15px] text-muted">
            {t('countries.section.subtitle')}
          </p>
        </div>
        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {countries.map((country) => (
            <li key={country.code}>
              <a
                href={country.path}
                onClick={() => trackEcommerceEvent('select_item', [buildEcommerceItem({
                  countryCode: country.code,
                  countryName: country.name,
                })], {
                  item_list_id: ITEM_LIST_ID,
                  item_list_name: ITEM_LIST_NAME,
                  transport_type: 'beacon',
                })}
                className="group flex flex-col items-center rounded-xl border border-border bg-surface p-5 transition hover:border-primary hover:bg-primary-soft cursor-pointer"
              >
                <img
                  src={`https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.2.3/flags/4x3/${country.flagCode}.svg`}
                  alt={`${t(`countries.${country.key}.name`)} flag`}
                  width={48}
                  height={36}
                  loading="lazy"
                  className="rounded-sm"
                />
                <div className="mt-3 text-[16px] font-semibold text-ink">{t(`countries.${country.key}.name`)}</div>
                <div className="mt-4 inline-flex items-center gap-1 rounded-md bg-primary px-4 py-2 text-[13px] font-semibold text-white transition group-hover:bg-primary-hover">
                  <span>{t('countries.getVignette')}</span>
                  <span>→</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
